// The only module in the feature that imports host store code (FE plan section 9): the host
// actions the feature listens to or dispatches, and the host state it reads. ESLint blocks `store/...`
// imports everywhere else in `features/stepByStepProtocol/`.
import { resolveTransactionId, transactionActions } from 'store/transactionsSlice/transactionsSlice';
import { formControlActions } from 'store/formControlSlice/formControlSlice';
import { selectFormsObject } from 'store/formControlSlice/formControlSelectors';

// Functions, not module-level constants: `store/store.js` loads this feature while
// `transactionsSlice` can still be evaluating (existing cycle through `utils/utils` ->
// `store/store`), so `transactionActions` is only safe to read once the saga runs.
export const getHostActionTypes = () => ({
    newTransaction: transactionActions.handleNewTransaction.type,
    closeTransactionPanel: transactionActions.closeTransactionPanel.type,
});

// The form actions a change in the form dispatches (`changeHandler` + `blurHandler` in
// `store/formControlSlice/fieldControllers.js`). Lazy for the same reason as above.
export const getHostFormActions = () => ({
    setFieldValueAndMarkEdited: formControlActions.setFieldValueAndMarkEdited,
    setFieldError: formControlActions.setFieldError,
    setFieldTouched: formControlActions.setFieldTouched,
    validateTransactionWithInventoryData: formControlActions.validateTransactionWithInventoryData,
    validateTransactionFormField: formControlActions.validateTransactionFormField,
});

const selectHostForm = (state, formId) => selectFormsObject(state)?.[formId];

export const selectHostFormFieldValue = (state, formId, fieldName) => selectHostForm(state, formId)?.form?.values?.[fieldName];

export const selectHostFormFieldError = (state, formId, fieldName) => !!selectHostForm(state, formId)?.form?.errors?.[fieldName];

// Every field of the location's form, as the form config carries them.
export const selectHostFormFields = (state, formId) => selectHostForm(state, formId)?.formConfig?.fields;

// The field's configuration (`dataField`, `lookup`, `validationField`, ...) from the location's form.
export const selectHostFormField = (state, formId, fieldName) =>
    selectHostFormFields(state, formId)?.find(({ dataField }) => dataField === fieldName) ?? null;

export { resolveTransactionId };
